import metainfo1 from "./1.js";
import metainfo2 from "./2.js";
import metainfo3 from "./3.js";
import metainfo4 from "./4.js";
import metainfo5 from "./5.js";
import metainfo6 from "./6.js";
import metainfo7 from "./7.js";
import metainfo8 from "./8.js";
import metainfo9 from "./9.js";
import metainfo10 from "./10.js";
import metainfo11 from "./11.js";
export default{
    metainfo1:metainfo1.metaInfo,
    metainfo2:metainfo2.metaInfo,
    metainfo3:metainfo3.metaInfo,
    metainfo4:metainfo4.metaInfo,
    metainfo5:metainfo5.metaInfo,
    metainfo6:metainfo6.metaInfo,
    metainfo7:metainfo7.metaInfo,
    metainfo8:metainfo8.metaInfo,
    metainfo9:metainfo9.metaInfo,
    metainfo10:metainfo10.metaInfo,
    metainfo11:metainfo11.metaInfo,

}


// WEBPACK FOOTER //
// ./src/data/metaInfo/index.js